import React from 'react'
import Moment from 'react-moment'
import { connect } from 'react-redux'
import { Form, Field, getFormValues, SubmissionError } from 'redux-form'
import { Modal, Button } from 'semantic-ui-react'
import { StdCard, FileUploadCell } from 'components'
import FieldAttachment from './FieldAttachment'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { AttachmentContainer, Cont, SContDetail, AttachmentGroup, AttachmentContent } from './styled'
import { updatePoAttachment, getPoDetail } from 'ducks/purchaseOrder'

const PurchaseOrderAttachment = (props) => {
  const { valueForm, isEdit, username, change, handleSubmit, history } = props
  const attachments = valueForm.attachments || []
  const commentAttachments = valueForm.commentAttachments || []

  const [showModal, setShowModal] = React.useState(false)

  function submitValidate(values) {
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
    return sleep(100) // simulate server latency
      .then(() => {
        var errors = {}

        if (!values.updateAttachmentComment || values.updateAttachmentComment.trim().length === 0) {
          errors.updateAttachmentComment = 'Required!'
        }

        if (['Duty01', 'Duty02'].includes(valueForm.stampDutyType)) {
          if (values.dutyType === undefined || values.dutyType === null || values.dutyType === '') {
            errors.dutyType = 'Required!'
          } else {
            if (valueForm.dutyType === 'eStamp') {
              if ((valueForm.PO27 || []).length === 0) {
                errors.PO27 = 'Required!'
              }
            }

            if (valueForm.dutyType === 'stampDuty') {
              if ((valueForm.PO28 || []).length === 0) {
                errors.PO28 = 'Required!'
              }
            }
          }
        } else {
          if (values.po03 === undefined ||
            values.po03 === null ||
            values.po03 === '' ||
            values.po03.length === 0) {
            errors.po03 = 'Required!'
          }
        }

        if (Object.keys(errors).length) {
          throw new SubmissionError(errors)
        } else {
          const data = { comment: values.updateAttachmentComment }
          if ((values.PO27 || []).length) { data.PO27 = values.PO27 }
          if ((values.PO28 || []).length) { data.PO28 = values.PO28 }
          if ((values.po03 || []).length) { data.po03 = values.po03 }

          props.updatePoAttachment(valueForm.id, data, () => { 
            change('updateAttachmentComment', '')
            change('dutyType', '')
            change('PO27', [])
            change('PO28', [])
            change('po03', [])
            setShowModal(false)
            props.getPoDetail(valueForm.id, history, true)
          })
        }
      }
    )
  }

  return (
    <React.Fragment>
      <StdCard 
        title='Attachments' 
        accessoriesHeader={
          valueForm.status === 4 &&
            (valueForm.requesterUser === username || valueForm.createdUser === username) ?
            <Button content='Update PO Attachment' onClick={() => {
              var attach = attachments.filter(x => ['PO27', 'PO28'].includes(x.documentCode)) || []
              if (attach.length > 0) {
                var files = []
                attach.forEach(x => { files = [...files, ...(x.items || [])] })
                files = files.sort((a, b) => a.createdDate > b.createdDate ? -1 : 1)
                if (files.length > 0) {
                  change('dutyType', files[0].documentCode === 'PO27' ? 'eStamp' : 'stampDuty')
                } else {
                  change('dutyType', 'stampDuty')
                }
              }
              setShowModal(true) 
            }} /> : null
        } 
        style={{ marginTop: '15px' }}
      >
        {isEdit ?
          <FieldAttachment />
          :
          <AttachmentContainer>
            <Cont>
              {
                attachments.map(a =>
                  <AttachmentGroup>
                    <div className='attachmentLabel'>{a.title}:</div>
                    <AttachmentContent>
                      {
                        a.items.map(f =>
                          <SContDetail style={{ marginTop: '0px' }}>
                            <FileUploadCell
                              fileName={f.originalFilename}
                              fileSize={f.size}
                              deletable={false}
                              urlPath={f.urlPath}
                            />
                          </SContDetail>
                        )
                      }
                    </AttachmentContent>
                  </AttachmentGroup>
                )
              }
            </Cont>
          </AttachmentContainer>
        }
        <br/>
        <div>
          <span>หมายเหตุ / Note: </span>
          <ul style={{marginTop:'0.3rem'}}>
            <li>รองรับได้สูงสุด 250 MB ต่อไฟล์ / The maximum file size is 250 MB (per file).</li>
            <li>ความเร็วและข้อผิดพลาดในการอัพโหลด/ดาวน์โหลดไฟล์ขนาดใหญ่ ขึ้นอยู่กับอินเตอร์เน็ตที่ท่านใช้งาน / The speed and error in uploading or downloading depend on your internet connection.</li>
          </ul>
        </div>
      </StdCard>
      {
        commentAttachments.length ?
          <StdCard title='Attachments (from comment)' style={{ marginTop: '15px' }} >
            <AttachmentContainer>
              <Cont>
                {
                  commentAttachments.map(a =>
                    <AttachmentGroup>
                      <div className='attachmentBy'>
                        <span>{a.uploadedName}</span>
                        <Moment format='DD MMM YYYY hh:mm'>{a.uploadedDate}</Moment>
                      </div>
                      <AttachmentContent>
                        {
                          (a.items || []).length > 0 ?
                            a.items[0].documentCode === 'PO27' ? '(Stamp Duty Receipt)' : 
                            a.items[0].documentCode === 'PO28' ? '(PO Affixed Stamp Duty)' : '' : ''
                        }
                        {
                          a.items.map(f =>
                            <SContDetail style={{ marginTop: '0px' }}>
                              <FileUploadCell
                                fileName={f.originalFilename}
                                fileSize={f.size}
                                urlPath={f.urlPath}
                                deletable={false} />
                            </SContDetail>
                          )
                        }
                      </AttachmentContent>
                    </AttachmentGroup>
                  )
                }
              </Cont>
            </AttachmentContainer>
          </StdCard> : null
      }
      <Modal
        open={showModal}
        onClose={() => {
          change('updateAttachmentComment', '')
          change('dutyType', '')
          change('PO27', [])
          change('PO28', [])
          change('po03', [])
          setShowModal(false)
        }}
      >
        <Modal.Header>Update PO Attachment</Modal.Header>
        <Modal.Content>
          <Form onSubmit={handleSubmit(() => submitValidate(valueForm))}>
            <Field
              name='updateAttachmentComment'
              label='Your Comment'
              require
              type={type.textArea}
              containerStyle={{ marginRight: '0px' }}
              component={FieldInput} />
            {
              ['Duty01', 'Duty02'].includes(valueForm.stampDutyType) ?
                <React.Fragment>
                  <div className='rowFields'>
                    <Field
                      name='dutyType'
                      type={type.radio}
                      options={[{
                        text: 'E-Stamp',
                        value: 'eStamp'
                      }, {
                        text: 'Stamp Duty',
                        value: 'stampDuty'
                      }]}
                      component={FieldInput}
                    />
                  </div>
                  <div className='rowFields'>
                    {
                      valueForm.dutyType === 'eStamp' ?
                        <Field name='PO27' label='Stamp Duty Receipt' require type={type.file} component={FieldInput} /> :
                      valueForm.dutyType === 'stampDuty' ?
                        <div>
                          <b>กรุณาอัพโหลดใบสั่งซื้อ(PO) ที่ลงนามโดย Vendor และติดอากรแสตมป์เรียบร้อยแล้ว</b>
                          <Field name='PO28' label='PO Affixed Stamp Duty' require type={type.file} component={FieldInput} />
                        </div> : null
                    }
                  </div>
                </React.Fragment> :
                <Field name='po03' label='Attachments' require type={type.file} component={FieldInput} />
            }
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Form onSubmit={handleSubmit(() => submitValidate(valueForm))}>
            <Button content='Submit' color='blue' />
            <Button content='Cancel' color='red' onClick={() => {
              change('updateAttachmentComment', '')
              change('dutyType', '')
              change('PO27', [])
              change('PO28', [])
              change('po03', [])
              setShowModal(false)
            }} />
          </Form>
        </Modal.Actions>
      </Modal>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => ({
  valueForm: getFormValues('formPO')(state) || {},
  username: state.authen.user ? state.authen.user.username ? state.authen.user.username : '' : ''
})

const mapDispatchToProps = {
  updatePoAttachment,
  getPoDetail
}

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseOrderAttachment)